export default __webpack_public_path__ + "static/media/illustration.07c518f3.png";